import { getTruncateMaxLinesStyle } from '@agilelab/plugin-wb-platform';
import {
  Box,
  Collapse,
  IconButton,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { WbTooltip } from '@agilelab/plugin-wb-platform';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import clsx from 'clsx';
import { CSSProperties, ReactNode } from 'react';

type ComponentAccordionProps = {
  label: string;
  className?: string;
  style?: CSSProperties;
  expanded: boolean;
  handleChange: () => void;
  children: ReactNode;
  handle: ReactNode;
  visibilityChecker: ReactNode;
};

const useStyles = makeStyles(
  theme => ({
    root: {
      backgroundColor: theme.palette.white,
      boxShadow: theme.shadows[1],
      borderRadius: theme.spacing(0.5),
      border: `1px solid ${theme.palette.grey[200]}`,
      paddingInline: theme.spacing(1),
      position: 'relative',
    },
    iconContainer: {
      padding: 0,
      transform: 'rotate(0deg)',
      '&$expanded': {
        transform: 'rotate(90deg)',
      },
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    label: {
      fontWeight: 700,
      color: theme.palette.secondary.dark,
      ...getTruncateMaxLinesStyle(1, false),
    },
    icon: {
      fontSize: '20px',
      color: theme.palette.secondary.main,
    },
    expanded: {},
    header: {
      paddingBlock: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      cursor: 'pointer',
    },
    itemList: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
    },
  }),
  { name: 'ComponentAccordion' },
);

export const ComponentAccordion = ({
  label,
  className,
  style,
  expanded,
  handleChange,
  children,
  visibilityChecker,
  handle,
}: ComponentAccordionProps) => {
  const classes = useStyles();
  return (
    <Box className={clsx(classes.root, className)} style={style}>
      {visibilityChecker}
      <Box className={classes.header} role="button" onClick={handleChange}>
        <IconButton
          onClick={e => {
            e.stopPropagation();
            handleChange();
          }}
          className={clsx(classes.iconContainer, expanded && classes.expanded)}
          size="small"
          aria-label={expanded ? 'collapse' : 'expand'}
        >
          <KeyboardArrowRightIcon color="primary" className={classes.icon} />
        </IconButton>
        <WbTooltip title={label}>
          <Typography className={classes.label}>{label}</Typography>
        </WbTooltip>
      </Box>
      {handle}
      <Collapse in={expanded}>
        <Box className={classes.itemList}>{children}</Box>
      </Collapse>
    </Box>
  );
};
